/*
 * Copyright (c) 2023-2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

// This component `FormItemStatusForwarder` is used to extract errors from the hidden input to the parent component.
import { Form } from 'antd'
import { ReactNode, useEffect } from 'react'

// Otherwise, we wouldn't be able to see the error.
export function FormItemStatusForwarder({ setErrors }: { setErrors: (errors: ReactNode[] | null) => void }) {
  const { errors } = Form.Item.useStatus()

  useEffect(() => {
    // This "errors" contain array of err message based on form fields
    // The reason of this slice because we just want to show 1 error message once at the time
    setErrors(errors.length ? errors.slice(0, 1) : null)
  }, [setErrors, errors])

  return null
}
